@if (savings.quantity > 1) {
  <b>{{ savings.quantity }} {{ savings.label | uppercase }}</b>
}

@if (savings.quantity === 1) {
  <b>{{ savings.label | uppercase }}</b>
}

<app-price [value]="savings.price"></app-price>
